(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-grade-inspection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pruuvo-grade-inspection')) {
    customElements.define('pruuvo-grade-inspection', class extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-pgi-config]').textContent);
        this.gradeKeys = ['superb', 'good', 'okay'];
        this.abort = new AbortController();
        this.restorations = new Map();
        this.paymentStates = new Map();
        this.selectedOptions = this.config.selectedOptions;
        this.pending = null;
        this.fromInspection = false;
        this.onLocalClick = this.onLocalClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentChange = this.onDocumentChange.bind(this);
        this.onTabKey = this.onTabKey.bind(this);
        this.addEventListener('click', this.onLocalClick, { signal: this.abort.signal });
        this.addEventListener('keydown', this.onTabKey, { signal: this.abort.signal });
        document.addEventListener('click', this.onDocumentClick, { capture: true, signal: this.abort.signal });
        document.addEventListener('change', this.onDocumentChange, { signal: this.abort.signal });
        document.addEventListener('submit', event => this.guardPurchase(event), { capture: true, signal: this.abort.signal });
        this.start = () => {
          this.bindVariantEvents();
          this.refresh();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true, signal: this.abort.signal });
        else this.start();
        window.addEventListener('load', () => this.bindVariantEvents(), { once: true, signal: this.abort.signal });
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.unsubscribe?.();
        clearTimeout(this.pendingTimer);
        this.lockAcceleratedCheckout(false);
        this.restorations?.forEach((state, element) => {
          element.hidden = state.hidden;
          if ('disabled' in element) element.disabled = state.disabled;
          element.className = state.className;
          for (const [name, value] of Object.entries(state.attributes)) {
            if (value === null) element.removeAttribute(name);
            else element.setAttribute(name, value);
          }
        });
      }

      normalize(value) { return String(value || '').trim().toLowerCase(); }

      get productInfo() {
        return Array.from(document.querySelectorAll('product-info[id^="MainProduct-"]')).find(node =>
          String(node.dataset.productId) === String(this.config.productId)
        ) || null;
      }

      get picker() { return this.productInfo?.querySelector('variant-selects') || null; }

      get groups() {
        if (!this.picker) return [];
        return Array.from(this.picker.querySelectorAll('fieldset, .product-form__input--dropdown')).filter(group =>
          group.querySelector('input[type="radio"], select')
        );
      }

      currentOptions() {
        return this.config.optionNames.map((name, index) => {
          const group = this.groups[index];
          return group?.querySelector('input[type="radio"]:checked')?.value || group?.querySelector('select')?.value || this.selectedOptions[index];
        });
      }

      variantForGrade(grade, options = this.currentOptions()) {
        if (this.config.conditionIndex < 0) return null;
        return this.config.variants.find(variant => variant.available && variant.options.every((value, index) =>
          index === this.config.conditionIndex ? this.normalize(value) === grade : value === options[index]
        ));
      }

      bindVariantEvents() {
        if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== String(this.productInfo?.dataset.section)) return;
          if (data.variant) this.selectedOptions = data.variant.options;
          this.refresh();
          this.confirmPending();
        });
      }

      setStatus(text) {
        const status = this.querySelector('[data-pgi-status]');
        status.textContent = text || '';
        status.hidden = !text;
      }

      lockAcceleratedCheckout(locked) {
        if (locked) {
          this.productInfo?.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach(element => {
            if (!this.paymentStates.has(element)) this.paymentStates.set(element, element.inert);
            element.inert = true;
          });
        } else {
          this.paymentStates.forEach((inert, element) => { element.inert = inert; });
          this.paymentStates.clear();
        }
      }

      remember(element) {
        if (!this.restorations.has(element)) this.restorations.set(element, {
          hidden: element.hidden, disabled: element.disabled, className: element.className,
          attributes: Object.fromEntries(['aria-disabled', 'tabindex', 'data-pgi-unavailable', 'data-pgi-sold-out', 'data-pgi-condition-label'].map(name => [name, element.getAttribute(name)]))
        });
      }

      setControlAvailability(element, available) {
        this.remember(element);
        element.hidden = false;
        if ('disabled' in element) element.disabled = !available;
        element.removeAttribute('data-pgi-unavailable');
        element.classList.remove('hidesold');
        element.setAttribute('aria-disabled', String(!available));
        element.toggleAttribute('data-pgi-sold-out', !available);
        if (element.tagName === 'LABEL') {
          element.setAttribute('data-pgi-condition-label', '');
          if (!available) element.tabIndex = -1;
          else {
            const original = this.restorations.get(element).attributes.tabindex;
            if (original === null) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', original);
          }
        }
      }

      refresh() {
        this.lockAcceleratedCheckout(Boolean(this.pending || this.failed));
        const options = this.currentOptions();
        this.selectedOptions = options;
        const currentGrade = this.normalize(options[this.config.conditionIndex]);
        let visibleCount = 0;
        let hasGradeImages = false;
        this.querySelectorAll('[data-pgi-grade]').forEach(tab => {
          const available = Boolean(this.variantForGrade(tab.dataset.pgiGrade, options));
          tab.hidden = false;
          tab.disabled = !available || Boolean(this.pending);
          tab.setAttribute('aria-disabled', String(tab.disabled));
          const active = tab.dataset.pgiGrade === currentGrade;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active && !tab.disabled ? 0 : -1;
          const panel = this.querySelector(`[data-pgi-panel="${tab.dataset.pgiGrade}"]`);
          panel.hidden = !active;
          if (Number(panel.dataset.pgiImageCount) > 0) hasGradeImages = true;
          if (available) visibleCount++;
        });
        const visibleTabs = Array.from(this.querySelectorAll('[data-pgi-grade]')).filter(tab => !tab.hidden && !tab.disabled);
        if (!visibleTabs.some(tab => tab.tabIndex === 0) && visibleTabs[0]) visibleTabs[0].tabIndex = 0;
        this.hidden = !this.config.designMode && (this.config.conditionIndex < 0 || !hasGradeImages);
        const conditionGroup = this.groups[this.config.conditionIndex];
        conditionGroup?.querySelectorAll('input[type="radio"], select option').forEach(control => {
          const grade = this.normalize(control.value);
          if (!this.gradeKeys.includes(grade)) return;
          const available = Boolean(this.variantForGrade(grade, options));
          this.setControlAvailability(control, available);
          if (control.tagName === 'INPUT') {
            Array.from(conditionGroup.querySelectorAll('label')).filter(label => label.htmlFor === control.id || label.contains(control)).forEach(label => this.setControlAvailability(label, available));
          }
        });
        if (visibleCount && !this.variantForGrade(currentGrade, options) && !this.pending) this.setStatus(this.config.unavailableText);
      }

      scrollToSection() {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.scrollIntoView({ behavior, block: 'start' });
      }

      onDocumentChange(event) {
        if (!this.productInfo?.contains(event.target)) return;
        if (event.target.matches('input[name="id"]')) {
          queueMicrotask(() => { if (this.isConnected) { this.refresh(); this.confirmPending(); } });
          return;
        }
        if (!this.picker?.contains(event.target)) return;
        this.setStatus(this.pending ? this.config.pendingText : '');
        this.refresh();
        if (!this.fromInspection && this.config.scrollOnSelect && this.groups[this.config.conditionIndex]?.contains(event.target)) this.scrollToSection();
      }

      onDocumentClick(event) {
        if (!(event.target instanceof Element)) return;
        const info = this.productInfo;
        const learn = event.target.closest('[data-condition-modal-open]');
        if (learn && info?.contains(learn) && !this.hidden) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.refresh();
          this.scrollToSection();
          return;
        }
        const purchase = event.target.closest('button[type="submit"], button[name="add"], .shopify-payment-button, [data-pruuvo-sticky-atc] button, .pruuvo-sticky-atc button');
        if (purchase) this.guardPurchase(event);
        const group = this.groups[this.config.conditionIndex];
        if (!group?.contains(event.target) || !this.config.scrollOnSelect) return;
        const label = event.target.closest('label');
        const radio = label ? Array.from(group.querySelectorAll('input[type="radio"]')).find(input => input.id === label.htmlFor) : event.target;
        if (radio?.matches('input[type="radio"]:checked') && !radio.hidden && !radio.disabled) {
          if (this.failed) this.selectGrade(this.normalize(radio.value));
          this.scrollToSection();
        }
      }

      onLocalClick(event) {
        const tab = event.target.closest('[data-pgi-grade]');
        if (tab && !tab.hidden && !tab.disabled) { this.selectGrade(tab.dataset.pgiGrade); return; }
        const thumbnail = event.target.closest('[data-pgi-thumbnail]');
        if (thumbnail) { this.showImage(thumbnail); return; }
        const arrow = event.target.closest('[data-pgi-direction]');
        if (arrow) {
          const gallery = arrow.closest('[data-pgi-gallery]');
          const thumbnails = Array.from(gallery.querySelectorAll('[data-pgi-thumbnail]'));
          const current = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
          const next = (current + Number(arrow.dataset.pgiDirection) + thumbnails.length) % thumbnails.length;
          if (thumbnails[next]) this.showImage(thumbnails[next]);
        }
      }

      showImage(thumbnail) {
        const gallery = thumbnail.closest('[data-pgi-gallery]');
        const image = gallery.querySelector('.pgi__image');
        image.srcset = thumbnail.dataset.srcset;
        image.src = thumbnail.dataset.src;
        image.alt = thumbnail.querySelector('img').alt;
        image.width = Number(thumbnail.dataset.width);
        image.height = Number(thumbnail.dataset.height);
        gallery.querySelectorAll('[data-pgi-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
        const track = gallery.querySelector('.pgi__thumbnails');
        const left = thumbnail.offsetLeft - track.offsetLeft;
        if (left < track.scrollLeft || left + thumbnail.offsetWidth > track.scrollLeft + track.clientWidth) track.scrollTo({ left, behavior: 'smooth' });
      }

      onTabKey(event) {
        if (!event.target.matches('[data-pgi-grade]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const tabs = Array.from(this.querySelectorAll('[data-pgi-grade]')).filter(tab => !tab.hidden && !tab.disabled);
        if (!tabs.length) return;
        event.preventDefault();
        const index = tabs.indexOf(event.target);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        tabs[next].focus();
        this.selectGrade(tabs[next].dataset.pgiGrade);
      }

      selectGrade(grade) {
        const variant = this.variantForGrade(grade);
        const group = this.groups[this.config.conditionIndex];
        if (!variant || !group || this.pending) { this.setStatus(this.config.errorText); return; }
        const actualValue = variant.options[this.config.conditionIndex];
        const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find(input => input.value === actualValue);
        const select = group.querySelector('select');
        if (!radio && !select) { this.setStatus(this.config.errorText); return; }
        if (this.normalize(this.currentOptions()[this.config.conditionIndex]) === grade && String(this.purchaseVariantId()) === String(variant.id) && !this.failed) return;
        this.pending = variant.id;
        this.setAttribute('aria-busy', 'true');
        this.setStatus(this.config.pendingText);
        this.pendingTimer = setTimeout(() => {
          if (!this.isConnected) return;
          this.confirmPending();
          if (this.pending) {
            this.pending = null;
            this.failed = true;
            this.removeAttribute('aria-busy');
            this.refresh();
            this.setStatus(this.config.errorText);
          }
        }, 12000);
        this.fromInspection = true;
        try {
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            select.value = actualValue;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } finally {
          this.fromInspection = false;
          this.refresh();
        }
      }

      purchaseVariantId() {
        return this.productInfo?.querySelector('form[data-type="add-to-cart-form"] input[name="id"], product-form form input[name="id"]')?.value;
      }

      confirmPending() {
        const options = this.currentOptions();
        const variant = this.config.variants.find(item => item.available && item.options.every((value, index) => value === options[index]));
        if (!variant || String(this.purchaseVariantId()) !== String(variant.id)) return;
        if (this.pending && String(this.pending) !== String(variant.id)) return;
        this.pending = null;
        this.failed = false;
        clearTimeout(this.pendingTimer);
        this.removeAttribute('aria-busy');
        this.setStatus('');
        this.refresh();
      }

      guardPurchase(event) {
        if (this.config.conditionIndex < 0) return;
        const target = event.target;
        const info = this.productInfo;
        const form = target.closest('form');
        const formOwner = target.closest('button')?.form;
        const belongs = info?.contains(target) || info?.contains(form) || info?.contains(formOwner) || target.closest('[data-pruuvo-sticky-atc], .pruuvo-sticky-atc');
        if (!belongs) return;
        const options = this.currentOptions();
        const expected = this.config.variants.find(variant => variant.available && variant.options.every((value, index) => value === options[index]));
        if (this.pending || this.failed || !expected || String(expected.id) !== String(this.purchaseVariantId())) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setStatus(this.pending ? this.config.pendingText : this.config.errorText);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
